import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { getBrandLogo } from './brandAssets';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const BrandCard = ({ brand, colors }) => {
  const [logoOk, setLogoOk] = useState(true);
  const logo = brand.logo_url || getBrandLogo(brand.name);
  return (
    <Link to={`/marque/${brand.slug}`}
      className="group flex flex-col items-center text-center" data-testid={`brand-card-${brand.slug}`}>
      <div className="w-24 h-24 md:w-[104px] md:h-[104px] rounded-full bg-white border border-slate-200 shadow-sm group-hover:shadow-xl group-hover:-translate-y-1 transition-all duration-300 flex items-center justify-center relative">
        <span className="mrg-brand-ring absolute inset-0 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{
            background: `conic-gradient(from 0deg, ${colors.accent}, ${colors.accent}00 35%, ${colors.accent}00 65%, ${colors.accent})`,
            WebkitMask: 'radial-gradient(farthest-side, #0000 calc(100% - 3px), #000 calc(100% - 3px))',
            mask: 'radial-gradient(farthest-side, #0000 calc(100% - 3px), #000 calc(100% - 3px))',
          }} />
        {logo && logoOk ? (
          <img src={logo} alt={brand.name} className="max-w-[78%] max-h-[64%] object-contain"
            onError={() => setLogoOk(false)} loading="lazy" />
        ) : (
          <span className="px-2 text-[13px] font-semibold uppercase tracking-tight text-center leading-tight"
            style={{ color: colors.primary, fontFamily: "'Poppins', sans-serif" }}>{brand.name}</span>
        )}
      </div>
      <span className="mt-3 text-[13px] font-semibold text-slate-800 group-hover:text-slate-900">{brand.name}</span>
      <span className="text-[11px] text-slate-400">{brand.product_count} modèle{brand.product_count > 1 ? 's' : ''}</span>
    </Link>
  );
};

export const BrandsCarousel = ({ colors }) => {
  const [brands, setBrands] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/s/mrg/brands?with_image=false`)
      .then(r => setBrands(Array.isArray(r.data) ? r.data : []))
      .catch(() => {});
  }, []);

  if (!brands.length) return null;
  const loop = [...brands, ...brands];

  return (
    <section className="py-14 md:py-16 bg-white overflow-hidden" data-testid="brands-carousel">
      <div className="max-w-[1320px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <span className="text-[12px] font-semibold uppercase tracking-[0.25em]" style={{ color: colors.accent }}>Nos marques</span>
            <h2 className="text-[26px] md:text-[34px] font-semibold text-slate-900 leading-tight mt-1" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Les plus grandes griffes
            </h2>
          </div>
          <Link to="/marques" className="text-[13px] font-semibold hover:underline shrink-0" style={{ color: colors.primary }}>
            Voir tout →
          </Link>
        </div>
      </div>

      {/* Marquee — 2 lignes, sens opposés */}
      <div className="relative mrg-brands-wrap space-y-4 md:space-y-6" data-testid="brands-marquee">
        <div className="flex gap-4 w-max mrg-track-1 px-4">
          {loop.map((b, i) => (
            <div key={`a-${b.id}-${i}`} className="w-[150px] md:w-[160px] shrink-0">
              <BrandCard brand={b} colors={colors} />
            </div>
          ))}
        </div>
        <div className="flex gap-4 w-max mrg-track-2 px-4">
          {[...loop].reverse().map((b, i) => (
            <div key={`b-${b.id}-${i}`} className="w-[150px] md:w-[160px] shrink-0">
              <BrandCard brand={b} colors={colors} />
            </div>
          ))}
        </div>
        {/* edge fades */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-24 bg-gradient-to-r from-white to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-24 bg-gradient-to-l from-white to-transparent z-10" />
      </div>

      <style>{`
        @keyframes mrgTrackL { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes mrgTrackR { from { transform: translateX(-50%); } to { transform: translateX(0); } }
        .mrg-track-1 { animation: mrgTrackL 75s linear infinite; }
        .mrg-track-2 { animation: mrgTrackR 75s linear infinite; }
        .mrg-brands-wrap:hover .mrg-track-1, .mrg-brands-wrap:hover .mrg-track-2 { animation-play-state: paused; }
        @keyframes mrgRingSpin { to { transform: rotate(360deg); } }
        .group:hover .mrg-brand-ring { animation: mrgRingSpin 3s linear infinite; }
      `}</style>
    </section>
  );
};

export default BrandsCarousel;
